export const LOCALE_COOKIE_NAME = 'NEXT_LOCALE'
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const PASSWORD_REGEX = /[A-Z]/
